import * as React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';

import { compose } from 'redux';
import Block from 'lqa-ui/lib/Components/Block';
import NonIdealState from 'lqa-ui/lib/Components/NonIdealState';
import FramePage from 'components/framePage/FramePage';
import Buttons from 'lqa-ui/lib/Components/Buttons';
import Button, { IButtonProps } from 'lqa-ui/lib/Components/Button';

interface IProps extends WithTranslation {
    title?: string;
    description?: string;
    buttons?: IButtonProps[];
}

class Error404 extends React.Component<IProps> {
    static displayName: string = 'Error404';

    render () {
        return (
            <FramePage title={this.props.t('error.Error 404')}>
                <Block>
                    <NonIdealState
                        title={this.props.title || this.props.t('error.Error 404')}
                        description={this.props.description || this.props.t('error.Page not found')}
                        intent="danger"
                        addOn={this.props.buttons && this.props.buttons.length > 0 && (
                            <Buttons layout="vertical">
                                {this.props.buttons.map((b, i) => (
                                    <Button
                                        key={i}
                                        {...b}
                                    />
                                ))}
                            </Buttons>
                        )}
                    />
                </Block>
            </FramePage>
        );
    }
}

export default compose<any>(
    withTranslation()
)(Error404);
